export default "__VITE_ASSET__61de9d1a__"